/**
 * Module to show Recently Viewed Products
 *
 * Copyright (c) 2014 Caroline Schnapp (11heavens.com)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 * 25/03/21 処理速度の高速化のためにチューニング（水野）
 */
Shopify.Products = (function() {
  var config = {
    howManyToShow: 8,
    howManyToStoreInMemory: 10,
    wrapperId: 'recently-viewed-products',
    templateId: 'recently-viewed-product-template',
    onComplete: null,
    recentlySectionId: null
  };

  var productHandleQueue = [];
  var wrapper = null;
  var shown = 0;

  var localStorageHandler = {
    name: 'shopify_recently_viewed',
    write: function(recentlyViewed) {
      localStorage.setItem(this.name, JSON.stringify(recentlyViewed));
    },
    read: function() {
      var recentlyViewed = localStorage.getItem(this.name);
      return recentlyViewed ? JSON.parse(recentlyViewed) : [];
    },
    destroy: function() {
      localStorage.removeItem(this.name);
    },
    remove: function(productHandle) {
      var recentlyViewed = this.read();
      var position = jQuery.inArray(productHandle, recentlyViewed);
      if (position !== -1) {
        recentlyViewed.splice(position, 1);
        this.write(recentlyViewed);
      }
    }
  };

  var finalize = function() {
    wrapper.show();
    if (config.onComplete) {
      try {
        config.onComplete();
      } catch (error) {
        console.error(error);
      }
    }
  };

  var moveAlongParallel = function() {
    const handles = productHandleQueue.slice(0, config.howManyToShow);
    if (!config.recentlySectionId) {
      config.recentlySectionId = "dag-recently-productlist";
    }

    const productHandlesParam = handles.join(",");
    const requests = handles.map(handle => {
      const requestUrl = `/products/${handle}?sections=${config.recentlySectionId}&product_handles=${encodeURIComponent(productHandlesParam)}`;
      return fetch(requestUrl)
        .then(res => res.ok ? res.json() : Promise.reject(res.status))
        .then(data => {
          if (!data || !data[config.recentlySectionId]) return null;

          const parser = new DOMParser();
          const doc = parser.parseFromString(data[config.recentlySectionId], "text/html");
          const productListItem = doc.querySelector("li");
          return productListItem ? { handle, html: productListItem.outerHTML } : null;
        })
        .catch(err => {
          localStorageHandler.remove(handle);
          return null;
        });
    });

    Promise.all(requests).then(results => {
      const targetContainer = document.querySelector("#js-recentlySliderBody");
      if (!targetContainer) return;
      const sectionId = targetContainer.dataset.sectionId;

      let productsHTML = "";
      results.forEach(result => {
        if (result && result.html) {
          productsHTML += result.html;
        }
      });

      if (productsHTML.trim().length > 0) {
        targetContainer.innerHTML = `
        <slider-component class="slider-mobile-gutter page-width page-width-desktop">
          <ul
            id="Slider-${sectionId}"
            data-id="${sectionId}"
            class="grid product-grid contains-card contains-card--product grid--4-col-desktop grid--2-col-tablet-down"
            role="list"
            aria-label="スライダー"
          >${productsHTML}</ul>
        </slider-component>`;

        if (window.Shopify && Shopify.Section && Shopify.Section.prototype.onLoad) {
          document.querySelectorAll("slider-component").forEach(slider => {
            new Shopify.Section.prototype.onLoad.call(slider);
          });
        }
      }else{
        targetContainer.innerHTML = `<p class="recently-empty-message">閲覧履歴はまだありません。</p>`;
      }      
    });
  };

  return {
    resizeImage: function(src, size) {
      if (!size || size === 'master') return src.replace(/http(s)?:/, "");
      var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?/i);
      if (match) {
        var prefix = src.split(match[0]);
        var suffix = match[0];
        return (prefix[0] + "_" + size + suffix).replace(/http(s)?:/, "");
      }
      return null;
    },

    showRecentlyViewed: function(params) {
      params = params || {};
      jQuery.extend(config, params);
      productHandleQueue = localStorageHandler.read();
      wrapper = jQuery('#' + config.wrapperId);
      config.howManyToShow = Math.min(productHandleQueue.length, config.howManyToShow);

      if (config.howManyToShow && wrapper.length) {
        moveAlongParallel();
      }else if (wrapper.length) {
        // 履歴が空だったときの表示処理
        const targetContainer = document.querySelector("#js-recentlySliderBody");
        if (targetContainer) {
          console.log("📭 閲覧履歴がゼロなので案内文を表示します");
          targetContainer.innerHTML = `<p class="recently-empty-message">閲覧履歴はまだありません。</p>`;
        }
      }
    },

    getConfig: function() {
      return config;
    },

    clearList: function() {
      localStorageHandler.destroy();
    },

    recordRecentlyViewed: function(params) {
      params = params || {};
      jQuery.extend(config, params);

      var recentlyViewed = localStorageHandler.read();
      if (window.location.pathname.indexOf('/products/') !== -1) {
        var productHandle = window.location.pathname.match(/\/products\/([^\/?]+)/)[1];
        var position = jQuery.inArray(productHandle, recentlyViewed);
        if (position === -1) {
          recentlyViewed.unshift(productHandle);
          recentlyViewed = recentlyViewed.splice(0, config.howManyToStoreInMemory);
        } else {
          recentlyViewed.splice(position, 1);
          recentlyViewed.unshift(productHandle);
        }
        localStorageHandler.write(recentlyViewed);
      }
    }
  };
})();